import React from 'react';
import SaveAndNavigate from '../Common/SaveAndNavigate';
import * as Constants from '../Common/CommonConstants';


export const NavControls = ({ questionnaireRef, formState, updateFormState, readOnlyText, cancelText, userName }) => {


    var retVal = null;

    if (userName) {
        retVal = <div className="navbar-welcome">
            Welcome {userName} !
    </div>
    }

    if (formState === Constants.ENTER_KEY_MODE || formState === Constants.DONE_MODE || formState === Constants.SHOW_ERROR_MODE || 
        formState === Constants.PORTAL_MODE)
        return retVal;

    return (
        <>
            {retVal}
            <SaveAndNavigate
                readOnlyMode={(formState === Constants.READ_ONLY_MODE)}
                navigateAway={(saveResult) => updateFormState(saveResult)}
                getDataHandler={questionnaireRef.questionnaireRef}
                pdfMode={(formState === Constants.READ_ONLY_MODE || formState === Constants.DONE_MODE)}
                cancelText={formState === Constants.READ_ONLY_MODE ? readOnlyText : cancelText} />
        </>
    )
}